<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>问题管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="small" type="primary" icon="el-icon-plus" @click="editFormVisible = true" style="margin-top: 20px;margin-bottom: 20px;">添加</el-button>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column prop="ask" label="问题">
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.type == '1'">判断</span>
          <span v-if="scope.row.type == '2'">单选</span>
          <span v-if="scope.row.type == '3'">多选</span>
          <span v-if="scope.row.type == '4'">简答</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" @change="editStatus(scope.row)"
          active-value="1" inactive-value="0">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="editque(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delque(scope.row.id,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="添加问题" :visible.sync="editFormVisible" width="800px" @click='editFormVisible = false'>
      <el-form label-width="60px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="题 库" prop="project">
          <el-input type="input" v-model="editForm.project" placeholder="请输入题库名称" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="问 题" prop="ask">
          <el-input type="textarea" v-model="editForm.ask" placeholder="请输入问题"></el-input>
        </el-form-item>
        <el-form-item label="类 型" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择类型">
            <el-option label="判断" value="1"></el-option>
            <el-option label="单选" value="2"></el-option>
            <el-option label="多选" value="3"></el-option>
            <el-option label="简答" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选 项" prop="reply" v-show="editForm.type == 2 || editForm.type == 3">
          <el-input class="change" type="textarea" v-model="editForm.reply" placeholder="选项间用符合&分割,例:选项1&选项2 "></el-input>
        </el-form-item>
        <el-form-item label="状 态" prop="status">
          <el-switch v-model="editForm.status" active-value='1' inactive-value='0'></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='editFormreset'>重置</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { saveQuestion,qusetionList,saveStatus,delQuestion } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false,
        editForm: {
          status: '1',
          type: '1'
        },
        // rules表单验证
        rules: {
          project: [
            { required: true, message: '请输入题库名称', trigger: 'blur' }
          ],
          ask: [
            { required: true, message: '请输入问题内容', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ]
        },
        // 请求数据参数
        formInline: {
          page: 1,
          limit: 10,
          key: ''
        },
        //表格数据
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      getdata(param) {
        this.loading = true;
        qusetionList(param).then(res => {
          this.loading = false;
          this.listData = res.data;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.count
        })
      },
      editFormreset() {
        this.editForm = {status: '1',type: '1'};
      },
      // 提交
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let data = this.editForm;
            saveQuestion(data)
            .then(res => {
              if(res.code == 0){
                this.editFormreset();
                this.editFormVisible = false;
                this.getdata(this.formInline);
                this.$message({
                  type: 'success',
                  message: res.msg
                });
              }else{
                this.$message.error(res.msg);
              }
            })
            .catch(e => {
              this.$message.error('操作失败，请稍后再试！')
            })
          } else {
            return false
          }
        })
      },
      editque(row) {
        row.type = row.type.toString();
        this.editForm = row;
        this.editFormVisible = true;
      },
      editStatus(row) {
        let data = {id:row.id,status:row.status};
        saveStatus(data)
        .then(res => {
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: res.msg
            });
          }else{
            this.$message.error(res.msg);
            this.getdata(this.formInline);
          }
        })
        .catch(e => {
          this.$message.error('操作失败，请稍后再试！')
          this.getdata(this.formInline);
        })
      },
      delque(id,index) {
        this.$confirm('您确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {id:id};
          delQuestion(data).then(res => {
            if(res.code == 0){
              this.listData.splice(index, 1);
              this.$message({
                type: 'success',
                message: res.msg
              });
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }

  }
</script>

<style>
  .change{margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/investigation/questions.vue